module.exports = __webpack_public_path__ + "img/02m_marketing.536771de.jpg";